<script>
    import Chart from 'chart.js/auto';
    import { onMount } from 'svelte';
    import { theme } from '../stores.js';

    //const urlAPI = "https://moonshot-nw.wotapool.net:5581/api/v1";
    //const poolHash = "pool130tcc6ls8nf0xslu222dcdph2ayp2tmkk429fdevx7mkg5zeun0";

    const urlAPI = "https://moonshot-nd.wotapool.net:5581/api/v1";
    const poolHash = 'pool1krznhwu3h5pu2stuslr53z5rme50t6384macsmylcnljwc7yjky';

    const light_background_color = 'rgb(255, 255, 255)';
    const light_grid_color = 'rgba(0, 0, 0, 0.05)';
    const light_legend_color = 'rgb(80, 85, 90)';
    const light_label_color = 'rgb(130, 135, 140)';

    const dark_background_color = 'rgb(50, 55, 60)';
    const dark_grid_color = 'rgba(255, 255, 255, 0.05)';
    const dark_legend_color = 'rgb(180, 185, 190)';
    const dark_label_color = 'rgb(110, 115, 120)';

    const blue_color = '#3e95cd';       
    const purple_color = '#be56ce';    // ac53ba   c338d8  d436ed
    const green_color = '#7bc149';    // 7bbc4d 82c950 50b707 5cbc18 6dc72e 

    let background_color = light_background_color;
    let grid_color = light_grid_color;
    let legend_color = light_legend_color;
    let label_color = light_label_color;

    let rosCanvas;
    let rosData;
    let rosChart;
    let forecast;

    let stakeCanvas;
    let stakeData;
    let stakeChart;

    let w;
    let chartSize;

    const t0 = new Date('2020-08-13T21:44:51Z');  // begin of epoch 211
    const dateFormat = { year: 'numeric', month: 'short', day: 'numeric' };

    Date.prototype.addDays = function (days) {
        const date = new Date(this.valueOf());
        date.setDate(date.getDate() + days);
        return date;
    };

    $: setChartTheme($theme)
    $: setChartStyle(w);
    
    function setChartTheme(theme) 
    {
        if (theme == 'light') {
            background_color = light_background_color;
            grid_color = light_grid_color;
            legend_color = light_legend_color;
            label_color = light_label_color;
        }
        else {
            background_color = dark_background_color;
            grid_color = dark_grid_color;
            legend_color = dark_legend_color;
            label_color = dark_label_color;
        }

        Chart.defaults.backgroundColor = background_color;
        Chart.defaults.color = legend_color;
        
        if (rosChart) {
            rosChart.options.scales.y1.grid.color = grid_color;
            rosChart.options.scales.y1.grid.borderColor = grid_color;
            rosChart.options.scales.y1.ticks.color = label_color;
            rosChart.options.scales.y2.grid.borderColor = grid_color;
            rosChart.options.scales.y2.ticks.color = label_color;
            rosChart.options.scales.xAxes.grid.borderColor = grid_color;
            rosChart.options.scales.xAxes.ticks.color = label_color;
            rosChart.update();
        }

        if (stakeChart) {
            stakeChart.options.scales.y_stake.grid.color = grid_color;
            stakeChart.options.scales.y_stake.grid.borderColor = grid_color;
            stakeChart.options.scales.y_delegators.grid.borderColor = grid_color;
            stakeChart.options.scales.xAxes.grid.borderColor = grid_color;
            stakeChart.options.scales.xAxes.ticks.color = label_color;
            stakeChart.update();
        }

        //console.log(Chart.defaults);
        //console.log(rosChart.options);
    }


    function setChartStyle(width) 
    {
        if (width == undefined) return;

        const desiredSize = (width < 480) ? 'small' : 'large';

        if (chartSize != desiredSize)
        {
            if (desiredSize == 'small') {
                rosChart.data.datasets[0].label = ' Return On Stake';
                rosChart.data.datasets[0].pointRadius = 0;
                rosChart.data.datasets[0].borderWidth = 2;
                rosChart.data.datasets[1].borderWidth = 2;
                rosChart.data.datasets[1].borderDash = [];

                stakeChart.data.datasets[0].pointRadius = 0;
                stakeChart.data.datasets[1].pointRadius = 0;
                stakeChart.data.datasets[0].borderWidth = 2;
                stakeChart.data.datasets[1].borderWidth = 2;
            }
            if (desiredSize == 'large') {
                rosChart.data.datasets[0].label = ' Annualized Return On Stake';
                rosChart.data.datasets[0].pointRadius = 3;
                rosChart.data.datasets[0].borderWidth = 3;
                rosChart.data.datasets[0].pointBorderWidth = 1;
                rosChart.data.datasets[1].borderWidth = 3;
                rosChart.data.datasets[1].pointBorderWidth = 1;
                rosChart.data.datasets[1].borderDash = [8,8];

                stakeChart.data.datasets[0].pointRadius = 3;
                stakeChart.data.datasets[1].pointRadius = 3;
                stakeChart.data.datasets[0].borderWidth = 3;
                stakeChart.data.datasets[1].borderWidth = 3;
                stakeChart.data.datasets[0].pointBorderWidth = 1;
                stakeChart.data.datasets[1].pointBorderWidth = 1;
            }
            chartSize = desiredSize;
        }
    }

    onMount(async () => {

        Chart.defaults.font.family = 'Open Sans';
        Chart.defaults.maintainAspectRatio = false;

        // INIT CHARTS
        initRosChart();
        initStakeChart();

        setChartTheme($theme);
                 
		const res = await fetch(urlAPI+"/pools/"+poolHash+"/rewards");   // TODO replace with /ros, less data
		rosData = await res.json();

        const res2 = await fetch(urlAPI+"/pools/"+poolHash+"/rewards/forecast");
		forecast = await res2.json();

        updateRosChart();

        const res3 = await fetch(urlAPI+"/pools/"+poolHash+"/stake");   
		stakeData = await res3.json();

        updateStakeChart();

	});

    function initRosChart()
    {
        const labels = [];

        const data = {
        labels: labels,
        datasets: [
            {
            label: ' Annualized Return On Stake',
            data: [],
            borderColor: blue_color,
            pointRadius: 3,
            },
            {
            label: ' 30 days moving average',
            data: [],
            borderColor: purple_color,
            borderDash: [8,8],
            pointRadius: 0,
            fill: false,
            lineTension: 0,
            }
        ]
        };

        const config = {
        type: 'line',
        data: data,
        options: {
            responsive: true,
            interaction: { mode: 'index', intersect: false, },
            stacked: false,
            plugins: {
                legend: {
                    display: true,
                    labels: { boxHeight: 0, boxWidth: 24 }
                },
                tooltip: {
                    titleMarginBottom: 10,
                    callbacks: {
                        label: function(context) { 
                            return context.dataset.label + ": " + Math.round(context.parsed.y*100)/100 + "%"; 
                        },
                        title: function(chart) {
                            let fc = "";
                            if (chart[0].dataIndex == rosData.length) fc = "  (forecasted)";
                            return "Epoch " + chart[0].label + fc;
                        },
                        afterTitle: function(chart) {
                            const elapsedDays = 5 * (chart[0].dataIndex-1);
                            const dateStart = t0.addDays(elapsedDays).toLocaleDateString(undefined, dateFormat);
                            const dateEnd = t0.addDays(elapsedDays+5).toLocaleDateString(undefined, dateFormat);
                            const dateRew = t0.addDays(elapsedDays+10).toLocaleDateString(undefined, dateFormat);
                            return `From  [${dateStart}]  to  [${dateEnd}]\nRewards distribution:  [${dateRew}]`;
                        },
                    },
                },
            },
            scales: {
                y1: {
                    type: 'linear', display: true, position: 'left',
                    align: 'start',
                    min: 0,
                    max: 9,
                    ticks: {
                        color: label_color,
                        callback: function(value, index, values) { return  value + '%'; }
                    },
                    grid: { color: grid_color, borderColor: grid_color }
                },
                y2: {
                    type: 'linear', display: true, position: 'right',
                    min: 0,
                    max: 9,
                    ticks: {
                        color: label_color,
                        callback: function(value, index, values) { return  value + '%'; }
                    },
                    grid: { drawOnChartArea: false, borderColor: grid_color },
                },
                xAxes: {
                    ticks: {
                        autoSkipPadding: 10,
                        maxRotation: 0,
                        color: label_color
                    },
                    grid: {
                        borderColor: grid_color, 
                        display: false
                    },
                },
            },
        },
        };

        const ctx = rosCanvas.getContext('2d');
        rosChart = new Chart(ctx, config);

    }

    function updateRosChart()
    {
        let labels = [];
        rosData.forEach((value, index) => {
            //if (index < (rosData.length-2)) {
                labels.push(+value.epoch_no);
            //}
        });

        //rosData[rosData.length-2].roa_compound = forecast[0].ros_forecasted_compound;

        let ros = [];
        let avg = [];
        let m = 0;
        rosData.forEach((value, index) => {
            //if (index < (rosData.length-1)) {
                if (index == 0 ) {
                    ros.push(null);
                    avg.push(null);
                }
                else {
                    ros.push(+value.roa_compound*100);
                    m += +value.roa_compound;
                    if(index > 5+1) m -= +rosData[index-6].roa_compound;
                    if(index >= 5+1) { avg.push((m/6)*100); }
                    else avg.push(null);
                }
            //} 
        });

        // add forecast
        labels.push(rosData[rosData.length-1].epoch_no+1);
        ros.push(+forecast[0].ros_forecasted_compound*100);
        m += +forecast[0].ros_forecasted_compound;
        m -= +rosData[rosData.length-6].roa_compound;
        avg.push((m/6)*100);

        rosChart.data.labels = labels;
        rosChart.data.datasets[0].data = ros;
        rosChart.data.datasets[1].data = avg;
        rosChart.update();
    }

    function initStakeChart()
    {
        const labels = [];

        const data = {
        labels: labels,
        datasets: [
            {
            label: ' Active Stake [Ada]',
            data: [],
            borderColor: blue_color,
            pointRadius: 3,
            yAxisID: 'y_stake',
            },
            {
            label: ' Delegators',
            data: [],
            borderColor: green_color,
            pointRadius: 3,
            yAxisID: 'y_delegators',
            }
        ]
        };

        const config = {
        type: 'line',
        data: data,
        options: {
            responsive: true,
            interaction: { mode: 'index', intersect: false, },
            stacked: false,
            plugins: {
                legend: {
                    display: true,
                    labels: { boxHeight: 0, boxWidth: 24 }
                },
                tooltip: {
                    callbacks: {
                        label: function(context) { 
                            var unit = "M";
                            if (context.datasetIndex == 1) unit = "";
                            return context.dataset.label + ": " + context.parsed.y + unit;
                        },
                        title: function(chart) {
                            return "Epoch " + chart[0].label;
                        },
                    },
                },
            },
            scales: {
                y_delegators: {
                    type: 'linear',
                    display: true,
                    position: 'left',
                    min: 0,
                    ticks: {
                      color: "#71b740",
                      padding: 1
                    },
                    grid: { drawOnChartArea: false, borderColor: grid_color },
                },
                y_stake: {
                    type: 'linear',
                    display: true,
                    position: 'right',
                    min: 0,
                    max: 64,
                    ticks: {
                      color: blue_color, // "#3b81ad",
                      padding: 0,
                      callback: function(value, index, values) { return  value + 'M'; }
                    },
                    grid: { color: grid_color, borderColor: grid_color }
                },
                xAxes: {
                    ticks: {
                        autoSkipPadding: 10,
                        maxRotation: 0,
                    },
                    grid: {
                        display: false, borderColor: grid_color
                    },
                },
            },
        },
        };

        const ctx = stakeCanvas.getContext('2d');
        stakeChart = new Chart(ctx, config);
    }

    function updateStakeChart()
    {
        let labels = [];
        let stake = [];
        let deleg = [];
        stakeData.forEach((value, index) => {
            if (index < (stakeData.length-1)) { // skip current epoch
                labels.push(+value.epoch_no);
                stake.push(Math.round(value.active_stake/10000)/100);
                deleg.push(value.delegators_count);
            } 
        });

        
        stakeChart.data.labels = labels;
        stakeChart.data.datasets[0].data = stake;
        stakeChart.data.datasets[1].data = deleg;
        stakeChart.update();
    }

</script>


<div class="container" bind:clientWidth={w}>
    <canvas bind:this={rosCanvas}></canvas>
    <canvas bind:this={stakeCanvas}></canvas>
</div>


<style>

    .container {
        width: 100%;
        display: flex;
        flex-direction: column;
        gap: 2.5em;
    }

    canvas {
        width: 100%;
        max-height: 300px;
    }

    /* PHONE */
    @media screen and (max-width: 480px)
    {
        canvas {
            max-height: 260px;
        }
    }
</style>